export default __webpack_public_path__ + "static/media/print_order_password_1.72c82c5b.jpg";